module.exports = __webpack_public_path__ + "img/mallVector.f13a5e6f.svg";